(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/video-player/assets/javascripts/content-loader.js') >= 0) return;  svs.modules.push('/components/components/video-player/assets/javascripts/content-loader.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var trinidad = isServer ? require('trinidad-core').core : {};
var _ref = isServer ? trinidad.components.require('utils', 'get-json-ld') : svs.utils,
  getJsonLDString = _ref.getJsonLDString;
var solidTangoUrl;
function loadVideo(options, callback) {
  if (options && options.type === 'solidtango') {
    var model = {
      type: 'solidtango',
      src: "https://".concat(solidTangoUrl, "/widgets/embed/").concat(options.videoId).concat(options.api ? '?api=true&autoFillScreen=0' : '?autoFillScreen=0'),
      heightPercent: options.height && options.width ? options.height / options.width * 100 : undefined,
      videoId: options.videoId,
      title: options.title ? options.title : 'video',
      height: options.height ? options.height : '1280',
      width: options.width ? options.width : '720'
    };
    var jsonLDTags = getJsonLDString({
      name: model.title,
      uploadDate: options.publishedAt
    });
    callback(null, _objectSpread(_objectSpread({}, model), {}, {
      jsonLDTags: jsonLDTags
    }));
  } else {
    callback('Unsupported media source type');
  }
}
if (isServer) {
  solidTangoUrl = require('trinidad-core').core.tpnsconfig.solidtango.host;
  module.exports = {
    loadVideo: loadVideo
  };
} else {
  solidTangoUrl = svs.core.config.data.svsconfig.solidTango || 'svspeltur.solidtango.com';
  svs.components.video_player.contentLoader = {
    loadVideo: loadVideo
  };
}

 })(window);